import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import Information from './components/Information';
import ContentsInformation from './components/ContentsInformation';
import ShowContainer from '../../shared/components/show/ShowContainer';

const Index = () => (
  <Container>
    <ShowContainer>
      {
        (resourceitem) => {
          if (Object.keys(resourceitem).length === 0) return null;
          return (
            <Container>
              <Information resourceitem={resourceitem} />
              <hr />
              <ContentsInformation resourceitem={resourceitem} />
            </Container>
          );
        }
      }
    </ShowContainer>
  </Container>
);

export default withRouter(connect()(Index));
